import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-39d7aab7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo" }, null, -1))
const _hoisted_3 = { class: "content" }
const _hoisted_4 = { class: "links" }
const _hoisted_5 = ["href"]
const _hoisted_6 = ["href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "info" }, [
  /*#__PURE__*/_createTextVNode(" COPYRIGHT © GENERAL INTERNATIONAL."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" TRADEMARKS BELONG TO THERE RESPECTIVE OWNERS. "),
  /*#__PURE__*/_createElementVNode("span", null, "ALL RIGHTS RESERVED")
], -1))

import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useInfo } from '@/store';
import { useI18n } from 'vue-i18n';

export default /*#__PURE__*/_defineComponent({
  __name: 'TheFooter',
  setup(__props) {

_useCssVars(_ctx => ({
  "41b2949c": (_unref(logo).pc),
  "4f6d7e3e": (_unref(logo).mobile)
}))

const { t } = useI18n();
const { policyLinks } = storeToRefs(useInfo());
const { getImg } = useInfo();
const logo = computed(() => ({
  pc: `url(${getImg('home_mobile_garena_logo')})`,
  mobile: `url(${getImg('home_pc_garena_logo')})`,
}));

return (_ctx: any,_cache: any) => {
  return (_unref(policyLinks))
    ? (_openBlock(), _createElementBlock("footer", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            (_unref(policyLinks).privacyPolicy)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: _unref(policyLinks).privacyPolicy
                }, _toDisplayString(_unref(t)('IW_PRIVACY_POLICY') || 'IW_PRIVACY_POLICY'), 9, _hoisted_5))
              : _createCommentVNode("", true),
            (_unref(policyLinks).forParents)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 1,
                  href: _unref(policyLinks).forParents
                }, _toDisplayString(_unref(t)('IW_FOR_PARENTS') || 'IW_FOR_PARENTS'), 9, _hoisted_6))
              : _createCommentVNode("", true)
          ]),
          _hoisted_7
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})